type Point = { x: number; y: number }

type StatRowProps = {
  label: string
  direction: 'down' | 'up'
  caption: string
  points: Point[]
}

// A divided data row, not a card. No box, no border-radius, no shadow, no
// lift-on-hover -- three identical bordered boxes in a grid reads as a
// generic template. The only feedback on hover is the trend line drawing
// itself in, which doubles as a reason to actually look at it.
export function StatRow({ label, direction, caption, points }: StatRowProps) {
  const path = points.map((p) => `${p.x},${p.y}`).join(' ')

  return (
    <div
      data-cursor="link"
      className="group grid gap-5 border-t border-n-200 py-10 min-[900px]:grid-cols-[minmax(0,0.9fr)_minmax(0,1.3fr)] min-[900px]:items-center min-[900px]:gap-16 min-[900px]:py-12"
    >
      <div>
        <p className="font-display text-3 italic text-ink">
          {label} <span className="text-flow">{direction === 'down' ? '↓' : '↑'}</span>
        </p>
        <p className="mt-2 max-w-[42ch] text-body text-n-500">{caption}</p>
      </div>
      <svg viewBox="0 0 100 60" className="h-20 w-full min-[900px]:h-24" aria-hidden="true">
        {points.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r={1} className="fill-n-500" />
        ))}
        <polyline
          points={path}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          // Visible by default; only devices with real mouse hover (the
          // [@media(hover:hover)] guard) get the opacity-0-until-hover
          // reveal. Without that guard, touch devices -- which have no
          // reliable :hover state -- never triggered group-hover, so the
          // line just never appeared and only the dots showed.
          className="opacity-100 transition-opacity duration-500 [@media(hover:hover)]:opacity-0 [@media(hover:hover)]:group-hover:opacity-100"
        />
      </svg>
    </div>
  )
}
